import { RequestActions } from '../../core/api/state';

const actions = {
  SIGN_IN: new RequestActions('[Auth] Sign in'),
  LOGOUT: new RequestActions('[Auth] Logout'),
  SET_AUTHENTICATED: '[Auth] Set Authenticated',
  setAuthenticated: (authenticaded: boolean) => ({
    type: actions.SET_AUTHENTICATED,
    payload: authenticaded,
  }),
  REFRESH_ACCESS_TOKEN: new RequestActions('[Auth] Refresh Acess Token'),
};

export default actions;
